import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { ApiWave } from "@/generated/models/ApiWave";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { GetWaveSubscription200Response } from "@/generated/models/GetWaveSubscription200Response";
export function useWaveNotificationSubscription(wave) {
  const $ = _c(7);
  const {
    seizeSettings
  } = useSeizeSettings();
  let t0;
  let t1;
  if ($[0] !== wave.id) {
    t0 = ["wave-notification-subscription", wave.id];
    t1 = () => commonApiFetch({
      endpoint: `notifications/wave-subscription/${wave.id}`
    });
    $[0] = wave.id;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!wave.id && wave.metrics.subscribers_count <= seizeSettings.all_drops_notifications_subscribers_limit;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      retry: _temp,
      retryDelay: _temp2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
}
function _temp2(failureCount_0) {
  return failureCount_0 * 1000;
}
function _temp(failureCount, error) {
  if (failureCount >= 3) {
    return false;
  }
  return true;
}